import React, { useContext, useState, useEffect } from 'react';
import {
  Pagination,
  Box,
  PaginationProps,
  NonCancelableCustomEvent,
} from '@amzn/awsui-components-core';

import CommunityCollectionCtx from './CommunityCollectionCtx';
import CollectionCardView from './CollectionCardView';
import { tablePaginationAriaLabels } from '../../../api/UtilsApi';

const NUMBER_OF_COLLECTION_PER_PAGE = 24;
const INITIAL_PAGE_INDEX = 1;

const CollectionCardsList = () => {
  const { filteredCollections, allCollections, searchTerm } = useContext(CommunityCollectionCtx);
  const [pageIndex, setPageIndex] = useState(INITIAL_PAGE_INDEX);

  const renderCollectionsList = () => {
    const displayCollections = filteredCollections.slice(
      NUMBER_OF_COLLECTION_PER_PAGE * (pageIndex - 1),
      NUMBER_OF_COLLECTION_PER_PAGE * pageIndex,
    );
    return displayCollections.map((collection) => {
      return <CollectionCardView key={collection.collectionId} collection={collection} />;
    });
  };

  const handlePageIndexChange = (event: NonCancelableCustomEvent<PaginationProps.ChangeDetail>) => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
    setPageIndex(event.detail.currentPageIndex);
  };

  const renderMatchedCollectionsNumber = () => {
    if (allCollections.length === filteredCollections.length) {
      return null;
    }
    return (
      <Box color="text-body-secondary">
        {searchTerm ? (
          <>
            {' '}
            for "<span className="home-page-publcation-match-term">{searchTerm}</span>"
          </>
        ) : null}
      </Box>
    );
  };

  useEffect(() => {
    setPageIndex(1);
  }, [filteredCollections]);

  const pageCount = Math.ceil(filteredCollections.length / NUMBER_OF_COLLECTION_PER_PAGE);
  return (
    <div>
      {renderMatchedCollectionsNumber()}
      <div className="home-page-publication-list">{renderCollectionsList()}</div>
      <Box float="right">
        <Pagination
          ariaLabels={tablePaginationAriaLabels}
          currentPageIndex={pageIndex}
          onChange={handlePageIndexChange}
          pagesCount={pageCount}
        />
      </Box>
    </div>
  );
};

export default CollectionCardsList;
